import {
  FlightOptions,
  ReturnFlightOptions,
} from '@shared/v2/services/types/api/parsedResponse';

export const isReturnFlightOptions = (
  flightOptions: FlightOptions | undefined,
): flightOptions is ReturnFlightOptions => {
  return !!flightOptions && 'returnJourneys' in flightOptions;
};
